import { useMemo, useState } from "react"
import copperData from "@data/rogue_5/copper.json"
import cls from "classnames"
import Modal from "@hg/modal"
import Scroll from "@hg/scroll"

import { useTranslation } from "@/locales"
// import { getRoguelikeItem } from "@/utils/assets"
import Close from "../Close"

import bgPng from "../../assets/img/copper/bg.png"
import bgWebP from "../../assets/img/copper/bg.webp"
import paper1Png from "../../assets/img/copper/paper-1.png"
import paper1WebP from "../../assets/img/copper/paper-1.webp"
import coupletPng from "../../assets/img/game/record/label.png"
import coupletWebP from "../../assets/img/game/record/label.webp"
import paper2Png from "../../assets/img/game/record/layer3.png"
import paper2WebP from "../../assets/img/game/record/layer3.webp"
import styles from "./index.module.less"

interface CopperModalProps {
    active: boolean
    onClose: () => void
}

const copperDict = copperData
    .flatMap((item) => item.items)
    .reduce<
        Record<
            string,
            {
                id: string
                name: string
                subtitle: string[]
                desc: string
            }
        >
    >((acc, item) => {
        acc[item.id] = item
        return acc
    }, {})

const CopperModal: React.FC<CopperModalProps> = (props) => {
    const { active, onClose } = props

    const { t } = useTranslation()

    const [selected, setSelected] = useState(Object.values(copperDict)[0].id)

    const desc = useMemo(() => {
        const line1 = copperDict[selected].desc.slice(0, 10)
        const line2 = copperDict[selected].desc.slice(10)
        return (
            <>
                {/*<div>{`${line1}`}</div>*/}
                {/*<div>{`${line2}`}</div>*/}
                <div>{`${copperDict[selected].desc}`}</div>
            </>
        )
    }, [selected])

    const getIndexInChinese = (index: number) => {
        const cnNums = [
            t("zh.0"),
            t("zh.1"),
            t("zh.2"),
            t("zh.3"),
            t("zh.4"),
            t("zh.5"),
            t("zh.6"),
            t("zh.7"),
            t("zh.8"),
            t("zh.9"),
        ]
        const cnUnits = ["", t("zh.10")]
        if (index === 0) return cnNums[0]
        let str = ""
        const numStr = index.toString()
        const len = numStr.length
        for (let i = 0; i < len; i++) {
            const num = parseInt(numStr[i])
            const unit = cnUnits[len - i - 1]
            if (num !== 0) {
                str += cnNums[num] + unit
            } else {
                // 只在下一个不是零时加零，且不是最后一位
                if (i < len - 1 && numStr[i + 1] !== "0") {
                    str += cnNums[0]
                }
            }
        }
        // 特殊处理 10-19 之间的数字
        if (index >= 10 && index < 20) {
            const reg = new RegExp(`^${t("zh.1")}${t("zh.10")}`)
            str = str.replace(reg, t("zh.10"))
        }
        return str
    }

    return (
        <Modal active={active}>
            <div
                className={cls(styles.copperModalEnter, {
                    [styles.copperModalActive]: active,
                })}
            >
                <div className={styles.bg}>
                    <picture className={styles.layer1}>
                        <source srcSet={paper1WebP} type="image/webp" />
                        <img src={paper1Png} alt="paper1" />
                    </picture>
                    <picture className={styles.layer2}>
                        <source srcSet={paper1WebP} type="image/webp" />
                        <img src={paper1Png} alt="paper1" />
                    </picture>
                    <picture className={styles.layer3}>
                        <source srcSet={paper2WebP} type="image/webp" />
                        <img src={paper2Png} alt="paper3" />
                    </picture>
                    <div className={styles.coin1} />
                    <div className={styles.coin2} />
                </div>
                <div className={styles.modalBg}>
                    <picture>
                        <source srcSet={bgWebP} type="image/webp" />
                        <img src={bgPng} alt="bg" />
                    </picture>
                    <div className={styles.content}>
                        <div className={styles.detail}>
                            <div className={styles.copperName}>
                                <div className={styles.name}>
                                    {copperDict[selected].name
                                        .split("")
                                        .map((char, index) => (
                                            <div
                                                key={index}
                                                className={styles.char}
                                            >
                                                <div className={styles.sub}>
                                                    {
                                                        copperDict[selected]
                                                            .subtitle[index]
                                                    }
                                                </div>
                                                <div className={styles.main}>
                                                    {char}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                                <div className={styles.coins}>
                                    {Array.from({ length: 4 }).map(
                                        (_, index) => (
                                            <div key={index} />
                                        )
                                    )}
                                </div>
                            </div>
                            <div className={styles.img}>
                                <div className={styles.imgBg}>
                                    <div className={styles.flower} />
                                    <div className={styles.hexagon} />
                                    <div className={styles.ray} />
                                </div>
                                <div
                                    className={styles.icon}
                                    style={{
                                        backgroundImage: `url(${__ASSETS_HOST}assets/img/static/rogue_5/copper/${selected}.png)`,
                                    }}
                                />
                            </div>
                            <div className={styles.desc}>{desc}</div>
                            <div className={styles.descSub}></div>
                        </div>
                        <Scroll
                            direction="y"
                            rotateDetection
                            scrollBar={false}
                            maskSize="2rem"
                            className={styles.groups}
                        >
                            {copperData.map((item) => (
                                <div key={item.id} className={styles.group}>
                                    <div
                                        className={styles.groupTitle}
                                        data-id={item.id}
                                    >
                                        <span>{item.name}</span>
                                    </div>
                                    <div className={styles.groupContent}>
                                        {item.items.map((item, index) => (
                                            <div
                                                key={item.id}
                                                className={cls(
                                                    styles.item,
                                                    selected === item.id &&
                                                        styles.selected
                                                )}
                                                onClick={() =>
                                                    setSelected(item.id)
                                                }
                                            >
                                                <img
                                                    className={styles.copper}
                                                    src={`${__ASSETS_HOST}assets/img/static/rogue_5/copper/${item.id}.png`}
                                                    loading="lazy"
                                                />
                                                <div className={styles.index}>
                                                    {getIndexInChinese(
                                                        index + 1
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </Scroll>
                        <div className={styles.corner}>
                            {t("game.copper.title")
                                .split("")
                                .map((char, index) => (
                                    <div key={index} className={styles.char}>
                                        {char}
                                    </div>
                                ))}
                        </div>
                    </div>
                    <picture className={styles.couplet}>
                        <source srcSet={coupletWebP} type="image/webp" />
                        <img src={coupletPng} alt="couplet" />
                    </picture>
                    <Close className={styles.close} onClick={onClose} />
                </div>
            </div>
        </Modal>
    )
}

export default CopperModal
